import { render, staticRenderFns } from "./Secured.vue?vue&type=template&id=541e45ce"
import script from "./Secured.vue?vue&type=script&lang=js"
export * from "./Secured.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('541e45ce')) {
      api.createRecord('541e45ce', component.options)
    } else {
      api.reload('541e45ce', component.options)
    }
    module.hot.accept("./Secured.vue?vue&type=template&id=541e45ce", function () {
      api.rerender('541e45ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Secured.vue"
export default component.exports